import * as Yup from 'yup';
import { createMediaSchema, dependantUrlTest } from '../../../utils/sharedSchema.utils';
import {
  IAddress,
  EFarmDisplayOption,
  ESiteDisplayOption,
} from 'FeatureModules/Auth/types/company.types';

export const companySchema = Yup.object().shape({
  name: Yup.string().required('Please enter your company name'),
  onlineShop: Yup.string().url(),
  website: Yup.string().url().required("Please enter your company's website"),
  social: Yup.object().shape({
    facebook: Yup.string().label('Facebook page').test(dependantUrlTest).nullable(),
    instagram: Yup.string().label('Instagram account').test(dependantUrlTest).nullable(),
    twitter: Yup.string().label('Twitter account').test(dependantUrlTest).nullable(),
  }),
  countriesOfBusiness: Yup.array().of(Yup.string()).default([]),
  vatNumber: Yup.string()
    .label('VAT number')
    .nullable()
    .default(null)
    .test('vatNumber', 'VAT number is not valid', value => {
      if (!value) return true; // If no value, skip validation
      // Simple regex for VAT number validation (this can be adjusted based on specific country formats)
      const vatRegex =
        /^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$/;
      return vatRegex.test(value);
    }),
  eoriNumber: Yup.string()
    .label('EORI number')
    .nullable()
    .default(null)
    .test('eoriNumber', 'EORI number is not valid', value => {
      if (!value) return true; // If no value, skip validation
      // Simple regex for EORI number validation (this can be adjusted based on specific country formats
      const eoriRegex = /^[A-Z]{2}[A-Z0-9]{8,15}$/; // Example regex for EORI numbers
      return eoriRegex.test(value);
    }),
});

export const addressSchema = Yup.object().shape({
  street: Yup.string().default('').required('This field is required'),
  streetNumber: Yup.string().default('').required('This field is required'),
  zipCode: Yup.string().default('').required('This field is required'),
  city: Yup.string().default('').required('This field is required'),
  country: Yup.string().default('').required('This field is required'),
}) as Yup.ObjectSchema<IAddress>;

export const companySchemaCombined = companySchema.concat(
  // @ts-ignore TODO: Check the error
  Yup.object().shape({
    logo: createMediaSchema('Please add a logo'),
    address: addressSchema,
  })
);

export const siteDisplayOptionSchema = Yup.object().shape({
  farmDisplayOption: Yup.string()
    .oneOf(Object.values(EFarmDisplayOption))
    .default(EFarmDisplayOption.FARM_NAME)
    .required(),
  siteDisplayOption: Yup.string()
    .oneOf(Object.values(ESiteDisplayOption))
    .default(ESiteDisplayOption.SITE_NAME)
    .required(),
}) as Yup.ObjectSchema<{
  farmDisplayOption: EFarmDisplayOption;
  siteDisplayOption: ESiteDisplayOption;
}>;
